module.exports = __webpack_public_path__ + "media/images/banner-right-image-6bdf2ab3dd4478a59ebf4721d7e3bc17.png";